import { render, staticRenderFns } from "./BaseModalExcluirItemExportacao.vue?vue&type=template&id=1e312ead&lang=pug"
import script from "./BaseModalExcluirItemExportacao.vue?vue&type=script&lang=js"
export * from "./BaseModalExcluirItemExportacao.vue?vue&type=script&lang=js"
import style0 from "./BaseModalExcluirItemExportacao.vue?vue&type=style&index=0&id=1e312ead&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports